import _ from "lodash";
import moment from "moment";
import React, { PropTypes } from "react";
import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedDate, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
    BILLING_PERIODS_CLIENT_ALL,
    DEPENDENT_COVERAGES,
    DEPENDENT_PERSON_COVERAGE_SYNCS,
} from "../../../../../../../../utils/data/models";
import { EditButton, Render } from "../../../../../../../common";
import { DataTable } from "../../../../../../../common/DataTable";
import genders from "../../../enums/genders";
import dependentRelations from "../enums/dependentRelations";

import simpleFetch from "../../../../../../../../../utils/simpleFetch";
import * as dataActions from "../../../../../../../../utils/data/dataActions";
import { RectangleSpinner } from "../../../../../../../common/spinners";
import { subProcessSyncType } from "../../../../synchronizations/synchronizationTypes";
import BasicDependentCoverageFields from "./BasicDependentCoverageFields";
import { dependentCoverageInactivityReasons, dependentCoverageStatuses } from "./enums/";
import { OTHER as OTHERINACTIVITYREASON } from "./enums/dependentCoverageInactivityReasons";
import dependentCoverageStudent from "./enums/dependentCoverageStudent";

import { toast } from "react-toastify";
import { CREATE_DATA_ITEM_FAILURE, UPDATE_DATA_ITEM_FAILURE } from "../../../../../../../../utils/data/dataActionTypes";
import {
    ADMINISTRATOR,
    AGENT,
    DIRECTOR,
    FINANCE,
    FINTECH,
    HR_CLERK,
    MANAGER,
    PLAN_ADMINISTRATOR,
} from "../../../../../../../../utils/Roles";
import userHasAccess from "../../../../../../../../utils/userHasAccess";
import { toLocaleDate } from "../../../../../../../common/dateHelper";
import { toCamelCase } from "../../../../../../../common/form/DBEnumStringHelper";
import { canViewSyncStatus, getLatestDependentSyncs, getOverlayForSync } from "../../../../../../../common/synchronization/SynchronizationHelper";
import { DEPENDENT_PERSON } from "../../../../../../synchronization/enums/syncElementTypes";
import { MANUAL, RECURRING } from "../../../../../enums/billingPeriodTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../../../../enums/clientStatusTypes";
import { ELIGIBILITY } from "../../../../../enums/synchronizationOptions";
import { FIRST_NAME, LAST_NAME } from "../../coverage/enums/invalidMemberNameSynchroTypes";

class DependentCoverages extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            latestCoverage: null,
            secondLatestCoverage: null,
            dependentCoverageSyncs: null,
            latestSyncs: null,
            isValidForSynchroConfirm: false,
            isClientValidForSynchro: false,
            isMemberValidForSynchro: false,
            currentUserRoleId: localStorage.getItem("roleId") || "",
        };

        this.createDependentCoverage = this.createDependentCoverage.bind(this);
        this.updateDependentCoverage = this.updateDependentCoverage.bind(this);
        this.getData = this.getData.bind(this);
        this.getViewOnlyForClientStatusType = this.getViewOnlyForClientStatusType.bind(this);
        this.dependentCoveragesSynchronizations = this.dependentCoveragesSynchronizations.bind(this);

        this.viewOnlyDependentCoverageForImplementation = !userHasAccess(FINANCE);
        this.viewOnlyDependentCoverageForActive = !userHasAccess([DIRECTOR, MANAGER, AGENT, PLAN_ADMINISTRATOR, FINTECH, ADMINISTRATOR, HR_CLERK], true);
        this.viewOnlyDependentCoverageForInactive = !userHasAccess([ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER, AGENT], true);
        this.viewOnlyDependentCoverageForTerminated = !userHasAccess(FINTECH);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.calculateCoverageDateLimits = this.calculateCoverageDateLimits.bind(this);
    }

    componentWillMount() {
        this.props.dataActions.clearDataList(DEPENDENT_COVERAGES);

        if (this.props.clientBillingPeriodsList.length <= 0) {
            //If Billing periods were not loaded (refresh)
            const billingPeriodFields = "billingPeriodId,endDate,startDate,localizations";
            const billingPeriodfilters = [`billingPeriods.clientId==${this.props.clientId}`];
            this.props.dataActions.getDataList(
                BILLING_PERIODS_CLIENT_ALL,
                0,
                0,
                "",
                ["startDate:desc"],
                billingPeriodfilters,
                null,
                {},
                billingPeriodFields
            );
        }
        const countryCodeCanada = "CA";
        const isClientValidForSynchro = this.props.activeClient.syncType === ELIGIBILITY.value &&
            this.props.activeClient.countryCode == countryCodeCanada &&
            this.props.activeClient.clientBillingPeriodType == RECURRING.value &&
            [ACTIVE.value, INACTIVE.value].includes(this.props.activeClient.clientStatusType);
        const isMemberValidForSynchro = !this.props.activeMember.isSyncDisabled && this.props.activeMember.countryCode == countryCodeCanada
            && this.props.activeMember.firstName != FIRST_NAME && this.props.activeMember.lastName != LAST_NAME;
        this.setState({
            isClientValidForSynchro: isClientValidForSynchro,
            isMemberValidForSynchro: isMemberValidForSynchro
        });
    }

    componentWillUpdate(nextProps) {
        if (nextProps.dependentPersonId != this.props.dependentPersonId) {
            this.setState({
                latestCoverage: null,
                secondLatestCoverage: null,
            });
            const filters = [`dependentPersonCoverages.dependentPersonId==${nextProps.dependentPersonId}`];
            this.getData(0, this.props.limit, this.props.q, this.props.sortBy, filters);
        }
    }

    getViewOnlyForClientStatusType() {
        const { clientStatusType, activeMember } = this.props;
        const isMemberArchived = activeMember && activeMember.isArchived && !userHasAccess(FINTECH);
        switch (clientStatusType) {
            case IMPLEMENTATION.value:
                return this.viewOnlyDependentCoverageForImplementation || isMemberArchived;
            case ACTIVE.value:
                return this.viewOnlyDependentCoverageForActive || isMemberArchived;
            case INACTIVE.value:
                return this.viewOnlyDependentCoverageForInactive || isMemberArchived;
            case TERMINATED.value:
                return this.viewOnlyDependentCoverageForTerminated || isMemberArchived;
        }
    }

    createDependentCoverage(values) {
        const isInactiveReasonType =
            !!values.isInactiveReasonType && values.isInactiveReasonType.trim() != ""
                ? values.isInactiveReasonType
                : null;
        const endDate = !!values.endDate && String(values.endDate).trim() ? values.endDate : null;
        this.props.dataActions
            .createDataItem(DEPENDENT_COVERAGES, {
                ...values,
                isInactiveReasonType,
                endDate,
            })
            .then((data) => {
                if (data.type === CREATE_DATA_ITEM_FAILURE) {
                    if (toCamelCase(data.payload.error.data.error) == "disabilityDatesOverlappingError") {
                        toast(<FormattedMessage id="dependentCoverages.errors.invalidUpdateDisabilityStartDateError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                    else if (toCamelCase(data.payload.error.data.error) == "coveragesDateOverlappingError") {
                        toast(<FormattedMessage id="dependentCoverages.errors.conflictedDatesError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                }
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
            });
    }

    createEmptyDependentCoverageModel(dependentPersonId) {
        let startDateLimit = null;
        if (!!this.state.latestCoverage) {
            startDateLimit = this.state.latestCoverage.endDate ? moment(toLocaleDate(this.state.latestCoverage.endDate)) :
                moment(toLocaleDate(this.state.latestCoverage.startDate)).add(1, 'days');
        }
        return {
            billingPeriodId: null,
            dependentPersonId,
            startDateLimit,
            isInactive: false,
            startDate: "",
            defineEndDate: null,
            endDate: null,
        };
    }

    updateDependentCoverage(values) {
        const isInactiveReasonType =
            !!values.isInactiveReasonType && values.isInactiveReasonType.trim() != ""
                ? values.isInactiveReasonType
                : null;
        const endDate = !!values.endDate && String(values.endDate).trim() ? values.endDate : null;
        delete values.dependentPersonCoveragePartnerHash;
        this.props.dataActions
            .updateDataItem(DEPENDENT_COVERAGES, {
                ...values,
                isInactiveReasonType,
                endDate,
            })
            .then((data) => {
                if (data.type === UPDATE_DATA_ITEM_FAILURE) {
                    if (toCamelCase(data.payload.error.data.error) == "disabilityDatesOverlappingError") {
                        toast(<FormattedMessage id="dependentCoverages.errors.invalidUpdateDisabilityStartDateError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                    else if (toCamelCase(data.payload.error.data.error) == "coveragesDateOverlappingError") {
                        toast(<FormattedMessage id="dependentCoverages.errors.conflictedDatesError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                }
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
            });
    }
    onStartDateChange(value, hasSuccess) {
        const { isClientValidForSynchro, isMemberValidForSynchro } = this.state;
        const isPlanAdministratorOrHRClerk = [PLAN_ADMINISTRATOR.roleId.toString(), HR_CLERK.roleId.toString()].includes(this.state.currentUserRoleId);
        if (isClientValidForSynchro && isMemberValidForSynchro && hasSuccess && isPlanAdministratorOrHRClerk) {
            this.setState({
                isValidForSynchroConfirm: value,
            });
        }
    }

    getCols() {
        const isManualClient = this.props.clientBillingPeriodType == MANUAL.value;
        let cols = [];

        if (isManualClient) {
            cols.push({
                name: <FormattedMessage id="dependentCoverages.datatable.columns.period" />,
                display: (dependentCoverage) => {
                    if (dependentCoverage.billingPeriodId && this.props.clientBillingPeriodsList.length > 0) {
                        const billingPeriod = _.find(
                            this.props.clientBillingPeriodsList,
                            { billingPeriodId: dependentCoverage.billingPeriodId },
                            { name: "" }
                        );
                        let name = "";
                        if (
                            billingPeriod &&
                            billingPeriod.hasOwnProperty("localizations") &&
                            billingPeriod.localizations.hasOwnProperty(this.props.authLanguageCode)
                        )
                            name = billingPeriod.localizations[this.props.authLanguageCode].name;
                        return <span>{name}</span>;
                    } else {
                        return <span />;
                    }
                },
                widthPct: 15,
            });
        }

        cols = cols.concat([
            {
                name: <FormattedMessage id="dependentCoverages.datatable.columns.date" />,
                display: (dependentCoverage) => {
                    if (dependentCoverage.endDate) {
                        return (
                            <span>
                                <FormattedDate
                                    value={toLocaleDate(dependentCoverage.startDate)}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    timeZone="UTC"
                                />
                                <span> - </span>
                                <FormattedDate
                                    value={toLocaleDate(dependentCoverage.endDate)}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    timeZone="UTC"
                                />
                            </span>
                        );
                    }

                    return (
                        <span>
                            <FormattedMessage id="dependentCoverages.datatable.columns.periodFrom" />
                            <FormattedDate
                                value={toLocaleDate(dependentCoverage.startDate)}
                                year="numeric"
                                month="long"
                                day="2-digit"
                                timeZone="UTC"
                            />
                        </span>
                    );
                },
                widthPct: isManualClient ? 14 : 18,
            },
            {
                name: <FormattedMessage id="dependentCoverages.datatable.columns.name" />,
                display: (dependentCoverage) => (
                    <span>{`${dependentCoverage.dependentPerson.firstName} ${dependentCoverage.dependentPerson.lastName}`}</span>
                ),
                widthPct: isManualClient ? 13 : 15,
            },
            {
                name: <FormattedMessage id="dependentCoverages.datatable.columns.relation" />,
                display: (dependentCoverage) => (
                    <FormattedMessage
                        id={
                            dependentRelations.find(
                                (relation) => relation.value == dependentCoverage.dependentPerson.relationshipType
                            ).key
                        }
                    />
                ),
                widthPct: isManualClient ? 9 : 10,
            },
            {
                name: <FormattedMessage id="dependentCoverages.datatable.columns.gender" />,
                display: (dependentCoverage) => (
                    <FormattedMessage
                        id={genders.find((gender) => gender.value == dependentCoverage.dependentPerson.genderType).key}
                    />
                ),
                widthPct: 6,
            },
            {
                name: <FormattedMessage id="dependentCoverages.datatable.columns.birthdate" />,
                display: (dependentCoverage) => (
                    <FormattedDate
                        value={toLocaleDate(dependentCoverage.dependentPerson.birthdate)}
                        year="numeric"
                        month="long"
                        day="2-digit"
                        timeZone="UTC"
                    />
                ),
                widthPct: isManualClient ? 12 : 13,
            },
        ]);
        if (!isManualClient) {
            cols.push({
                name: <FormattedMessage id="dependentCoverages.datatable.columns.student" />,
                display: (dependentCoverage) => (
                    <FormattedMessage
                        id={
                            dependentCoverageStudent.find((student) => student.value == dependentCoverage.isStudent).key
                        }
                    />
                ),
                widthPct: 7,
            });
        }
        cols.push({
            name: <FormattedMessage id="dependentCoverages.datatable.columns.status" />,
            display: (dependentCoverage) => {
                const isInactive = dependentCoverage.isInactive && dependentCoverage != "false";
                const reasonType = dependentCoverageInactivityReasons.find(
                    (reason) => reason.value == dependentCoverage.isInactiveReasonType
                );
                const message =
                    isInactive && reasonType ? (
                        reasonType == OTHERINACTIVITYREASON ? (
                            dependentCoverage.isInactiveOtherReason
                        ) : (
                            <FormattedMessage id={reasonType.key} />
                        )
                    ) : null;
                const tooltip = isInactive ? <Tooltip id="tooltip">{message}</Tooltip> : null;

                const StatusOverlay = (props) => {
                    return !!props.overlay ? (
                        <OverlayTrigger placement={props.placement} overlay={props.overlay}>
                            {props.children}
                        </OverlayTrigger>
                    ) : (
                        <div>{props.children}</div>
                    );
                };

                return (
                    <div className={`status-indicator status-${isInactive ? "inactive" : "active"}`}>
                        <StatusOverlay placement="top" overlay={tooltip}>
                            <span>
                                <FormattedMessage
                                    id={
                                        dependentCoverageStatuses.find(
                                            (status) => status.value == dependentCoverage.isInactive
                                        ).key
                                    }
                                />
                            </span>
                        </StatusOverlay>
                    </div>
                );
            },
            widthPct: isManualClient ? 9 : 10,
        },);
        if (canViewSyncStatus(this.props.activeClient, DEPENDENT_PERSON)) {
            cols.push({
                name: <FormattedMessage id="dependentCoverages.datatable.columns.sync" />,
                display: (dependentCoverage) => this.dependentCoveragesSynchronizations(dependentCoverage),
                widthPct: 6,
            });
        }
        cols.push({
            name: <FormattedMessage id="datatable.actions" />,
            display: (dependentCoverage) => this.generateActionButtons(dependentCoverage),
            widthPct: 15,
        });
        return cols;
    }

    dependentCoveragesSynchronizations(dependentCoverage) {
        const { latestSyncs } = this.state;
        if (!latestSyncs) {
            return <RectangleSpinner className="spinner-rect-col" />;
        }
        const latestDependentPersonCoverageSync = latestSyncs["dependentPersonCoverageSyncs"].find(
            (coverage) => coverage.dependentPersonCoverageId == dependentCoverage.dependentPersonCoverageId
        );
        let memberCopy = _.cloneDeep(this.props.activeMember);
        memberCopy.memberCoverages = this.props.allMemberCoverages && this.props.allMemberCoverages.items;
        const data = { "dependentCoverage": _.cloneDeep(dependentCoverage), "member": memberCopy, "client": this.props.activeClient };
        return getOverlayForSync(data, latestDependentPersonCoverageSync, "dependentCoverages.datatable", "dependentPersonCoveragePartnerHash", "dependentPersonCoveragePartnerHash", "dependentCoverage");
    }

    calculateCoverageDateLimits(currentDependentCoverageId) {
        const dependentCoverages = this.props.items;

        if (!Array.isArray(dependentCoverages) || dependentCoverages.length === 0) {
            return { startDateLimit: null, endDateLimit: null };
        }

        // Normalize & clone to prevent accidental mutation
        const coverages = dependentCoverages
            .map(dc => {
                const start = dc.startDate
                    ? moment(toLocaleDate(dc.startDate)).startOf("day")
                    : null;

                const end = dc.endDate
                    ? moment(toLocaleDate(dc.endDate)).startOf("day")
                    : null;

                return {
                    ...dc,
                    start: start ? start.clone() : null,
                    end: end ? end.clone() : null
                };
            })
            .filter(dc => dc.start || dc.end)
            .sort((a, b) => {
                const aTime = a.start ? a.start.valueOf() : 0;
                const bTime = b.start ? b.start.valueOf() : 0;
                return aTime - bTime;
            });

        let startDateLimit = null;
        let endDateLimit = null;

        const latest = coverages[coverages.length - 1];
        if (latest && latest.start) {
            if (latest.end) {
                startDateLimit = latest.start.clone();
            } else {
                startDateLimit = latest.start.clone().add(1, "day");
            }
        }

        const defaultLimits = {
            startDateLimit: startDateLimit ? startDateLimit.clone() : null,
            endDateLimit: latest && latest.end ? latest.end.clone() : null
        };

        const index = coverages.findIndex(dc =>
            dc.dependentPersonCoverageId === currentDependentCoverageId
        );

        if (index === -1) {
            return defaultLimits;
        }

        const prev = coverages[index - 1];
        const next = coverages[index + 1];

        startDateLimit = null;
        endDateLimit = null;

        if (prev) {
            if (prev.end) {
                startDateLimit = prev.end.clone();
            } else if (prev.start) {
                startDateLimit = prev.start.clone().add(1, "day");
            }
        }

        if (next && next.start) {
            endDateLimit = next.start.clone();
        }

        return {
            startDateLimit: startDateLimit ? startDateLimit.clone() : null,
            endDateLimit: endDateLimit ? endDateLimit.clone() : null
        };
    }


    generateActionButtons(dependentCoverage) {
        const { clientBillingPeriodType, clientId } = this.props;
        const viewOnly = this.getViewOnlyForClientStatusType();
        const { startDateLimit, endDateLimit } = this.calculateCoverageDateLimits(dependentCoverage.dependentPersonCoverageId);

        return (
            <ButtonToolbar key={dependentCoverage.dependentPersonCoverageId}>
                <EditButton
                    title={
                        <FormattedMessage id={`dependentCoverages.datatable.actions.${viewOnly ? "view" : "edit"}`} />
                    }
                    label={<FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />}
                    form={BasicDependentCoverageFields}
                    allowSubmission={!viewOnly}
                    data={{
                        ...dependentCoverage,
                        isInactive: dependentCoverage.isInactive,
                        startDate: moment(toLocaleDate(dependentCoverage.startDate)),
                        defineEndDate: dependentCoverage.endDate ? true : null,
                        endDate: dependentCoverage.endDate ? moment(toLocaleDate(dependentCoverage.endDate)) : null,
                        startDateLimit: startDateLimit,
                        endDateLimit: endDateLimit
                    }}
                    props={{
                        clientBillingPeriodType,
                        clientId,
                        latestCoverage: this.state.secondLatestCoverage,
                        disabled: viewOnly,
                        onStartDateChange: this.onStartDateChange,
                        dependentPersonCoverageId: dependentCoverage.dependentPersonCoverageId,
                        allDependentCoverages: this.props.items
                    }}
                    confirmationValidMessage={() => (
                        <FormattedMessage
                            id="clients.client.processSync.coverageStartDateWarning"
                        />
                    )}
                    confirmationTitle={
                        <FormattedMessage id="common.confirmationWarningTitle">

                            {(f) => <span className="icon warning">{f}</span>}
                        </FormattedMessage>
                    }
                    closeButtonKey="common.cancel"
                    confirmOnClose={true}
                    requiresConfirmation={this.state.isValidForSynchroConfirm}
                    editFunction={this.updateDependentCoverage}
                />
            </ButtonToolbar>
        );
    }

    generateAddButton(dependentPersonId) {
        const { clientBillingPeriodType, clientId } = this.props;
        const { latestCoverage } = this.state;

        return (
            <Render for={AGENT} exactly={[PLAN_ADMINISTRATOR, HR_CLERK]}>
                <EditButton
                    title={<FormattedMessage id="dependentCoverages.datatable.actions.add" />}
                    label={<FormattedMessage id="common.add" />}
                    add={true}
                    form={BasicDependentCoverageFields}
                    data={this.createEmptyDependentCoverageModel(dependentPersonId)}
                    props={{ clientBillingPeriodType, clientId, latestCoverage, onStartDateChange: this.onStartDateChange, }}
                    editFunction={this.createDependentCoverage}
                />
            </Render>
        );
    }

    getData(offset, limit, q, sortBy, filters) {
        const hasAdminAccess = userHasAccess([ADMINISTRATOR, FINTECH], true);
        this.props.dataActions.clearDataList(DEPENDENT_COVERAGES);
        return this.props.dataActions
            .getDataList(
                DEPENDENT_COVERAGES,
                offset,
                limit,
                q,
                sortBy,
                filters,
                null,
                { memberId: this.props.memberId },
                "*,coverageGuarantees(*)"
            )
            .then((data) => {
                if (canViewSyncStatus(this.props.activeClient, DEPENDENT_PERSON)) {
                    const dependentPersonIds = data.payload.data.items.map((d) => d.dependentPersonId);
                    getLatestDependentSyncs(this.props.clientId, dependentPersonIds, this.props.dataActions, (response) => {
                        const latestSyncs = response.payload.data;
                        this.setState({ latestSyncs });
                    }).catch(() => {
                        this.setState({ latestSyncs: [] });
                    });
                }
                const datum = data.payload.data;
                if (datum.pagination.offset == 0 && datum.pagination.totalCount != 0 && q == "") {
                    this.setState({
                        latestCoverage: datum.items[0],
                        secondLatestCoverage: datum.items[1],
                    });
                }
                if (hasAdminAccess) {
                    simpleFetch("GET", DEPENDENT_PERSON_COVERAGE_SYNCS.path.replace("{}", this.props.clientId), {
                        query: {
                            dependentPersonIds: [this.props.dependentPersonId],
                            sortBy: ["dependentPersonCoverageId:desc", "createdAt:desc"],
                            filters: `subProcessSync.status==${subProcessSyncType.SUCCESS}`,
                        },
                    }).then((res) => {
                        if (res && res.length > 0) {
                            this.setState({ dependentCoverageSyncs: res });
                        } else {
                            this.setState({ dependentCoverageSyncs: [] });
                        }
                    });
                } else this.setState({ dependentCoverageSyncs: [] });
            });
    }

    render() {
        const canAddDependentCoverage = !this.getViewOnlyForClientStatusType();

        return (
            <DataTable
                ref="dataTable"
                title={<FormattedMessage id="dependents.title" />}
                getData={this.getData}
                cols={this.getCols()}
                q={this.props.q}
                filters={this.props.filters}
                offset={this.props.offset}
                data={this.props.items}
                rowsPerPage={this.props.limit}
                totalRows={this.props.total}
                sortBy={this.props.sortBy}
                addButton={canAddDependentCoverage && this.generateAddButton(this.props.dependentPersonId)}
                refreshFunction={this.getData}
            />
        );
    }
}

DependentCoverages.propTypes = {
    authLanguageCode: PropTypes.string,
    clientBillingPeriodsList: PropTypes.array,
    clientBillingPeriodType: PropTypes.string,
    clientId: PropTypes.number,
    dataActions: PropTypes.object,
    filters: PropTypes.array,
    q: PropTypes.string,
    items: PropTypes.array,
    limit: PropTypes.number,
    dependentPersonId: PropTypes.string,
    memberId: PropTypes.number,
    offset: PropTypes.number,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    clientStatusType: PropTypes.string,
    activeMember: PropTypes.object,
    allMemberCoverages: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    activeClient: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    const data = state.data.dependentCoverages || {};
    const pagination = data.pagination || {};
    const billingPeriodsData = state.data.billingPeriodsClientAll || {};
    const dependentPersonId = ownProps.params.dependentId;
    const activeClient = state.data.clients.active;
    const activeMember = state.data.members.active;
    const allMemberCoverages = state.data.allMemberCoverages;

    return {
        activeMember,
        activeClient,
        allMemberCoverages,
        authLanguageCode: state.auth.user.languageCode,
        dependentPersonId,
        clientBillingPeriodsList: billingPeriodsData.items || [],
        clientBillingPeriodType: activeMember.client.clientBillingPeriodType,
        clientId: activeClient.clientId,
        memberId: activeMember.memberId,
        filters: [
            `dependentPersonCoverages.dependentPersonId==${dependentPersonId}`,
        ],
        items: data.items || null,
        limit: pagination.limit || 100,
        offset: pagination.offset || 0,
        q: "",
        sortBy: ["startDate:desc"],
        total: pagination.totalCount || 0,
        clientStatusType: activeClient.clientStatusType
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DependentCoverages);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/coverages/DependentCoveragesDataTable.js